import { useRecurly } from '@recurly/react-recurly';
import { Button, Checkbox, Form, Icon } from 'antd';
import React, { useEffect, useState } from 'react';
import { SSC_TOS_URL } from '../../settings/config';
import { Token } from '../types';

type Props = {
    buttonLabel: string;
    onToken: (token: Token) => void;
};

export default function PayPalForm({ buttonLabel, onToken }: Props) {
    const recurly = useRecurly();
    const payPal = recurly.PayPal({
        display: { displayName: 'SEO Site Checkup subscription' },
    });

    const [acceptTos, setAcceptTos] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handlePlaceOrderClicked = () => {
        setIsLoading(true);
        payPal.start();
    };

    useEffect(() => {
        payPal.on('token', (token) => {
            setIsLoading(false);
            onToken(token);
        });

        payPal.on('error', () => {
            setIsLoading(false);
        });

        payPal.on('cancel', () => {
            setIsLoading(false);
        });
    }, [onToken, payPal]);

    return (
        <Form>
            <Form.Item className="paypal-accept-terms">
                <Checkbox onChange={() => setAcceptTos(!acceptTos)}>
                    I accept the&nbsp;
                    <a
                        href={SSC_TOS_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Terms of Service
                    </a>
                </Checkbox>
            </Form.Item>

            <Form.Item>
                <Button
                    className={`place-order ${!acceptTos ? 'disabled' : ''}`}
                    type="primary"
                    disabled={!acceptTos}
                    loading={isLoading}
                    block
                    onClick={handlePlaceOrderClicked}
                >
                    {buttonLabel}
                    <Icon
                        type="lock"
                        theme="filled"
                    />
                </Button>
            </Form.Item>
        </Form>
    );
}
